import { Button, useI18n } from '@ywwwtseng/react-kit';
import { openWebLink } from '@ywwwtseng/tma-react-kit';

const PANCAKESWAP_URL = 'https://pancakeswap.finance/swap?chain=bsc&inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0xe4d5857271c7978F5fe6b29A73C97142D6d8Befe';

export function BuyMooniniButton() {
  const { t } = useI18n();

  return (
    <Button
      className="font-semibold"
      variant="contained"
      color="#FFBA00"

      textColor="black"
      rounded="full"
      size="sm"
      onClick={() => {
        openWebLink(PANCAKESWAP_URL);
      }}
    >
      {t('common.get_moonini')}
    </Button>
  );
}
